export default __webpack_public_path__ + "static/media/IMG_022_Finished.74712bdb.jpg";